/**
 * Banner version registry — single source of truth for dismissal storage keys.
 *
 * HOW TO UPDATE BANNER COPY
 * ─────────────────────────
 * 1. Increment the `currentKey` suffix for the relevant banner
 *    (e.g. "hideAlumniBanner_v1" → "hideAlumniBanner_v2").
 * 2. Move the old key into the `staleKeys` array for that banner.
 *
 * On every page load, `purgeStalebannerKeys()` (called from main.tsx) removes
 * every stale key from visitors' localStorage so they see the updated banner
 * instead of the previously dismissed state.
 */
export const BANNER_VERSIONS = {
  alumni: {
    currentKey: "hideAlumniBanner_v1",
    staleKeys: [] as string[],
  },
  recruiter: {
    currentKey: "hideRecruiterBanner_v2",
    staleKeys: ["hideRecruiterBanner_v1"] as string[],
  },
  jobSafety: {
    currentKey: "hideJobSafetyBanner_v1",
    staleKeys: ["carry_dismissed_job_safety_banner"] as string[],
  },
  linkedinUrlMissing: {
    currentKey: "hideLinkedinUrlMissingBanner_v1",
    staleKeys: [] as string[],
  },
} satisfies Record<string, { currentKey: string; staleKeys: string[] }>;

/**
 * Remove all stale banner dismissal keys from localStorage.
 * Call once at app startup (see main.tsx).
 */
export function purgeStalebannerKeys(): void {
  try {
    for (const banner of Object.values(BANNER_VERSIONS)) {
      for (const staleKey of banner.staleKeys) {
        localStorage.removeItem(staleKey);
      }
    }
  } catch {
    // localStorage may be unavailable (private browsing, etc.) — non-fatal
  }
}
